import {getType, types} from "mobx-state-tree";
import DataDeliveryTypeStore from "../../../stores/domain/DataDeliveryTypeStore";
import {DataDeliveryType} from "../../../models/data/exports/DataDeliveryType";

export const DataDeliveryTypeSelectState = types.model('DataDeliveryTypeSelectState',{
  selectStateUuid: types.identifier,
  store: types.maybe(types.late(() => types.reference(DataDeliveryTypeStore))),
  selected: types.maybe(types.safeReference(DataDeliveryType))
}).volatile(self => ({
  notifySelect: types.function,
})).actions((self)=>({
  setConsumer(func){
    self.notifySelect = func;
  },
  search(data) {},
  select(option) {
    self.notifySelect(option);
    self.selected = option;
  },
  afterCreate() {
    console.log(`Instantiated: ${getType(self).name}`);
    self.notifySelect = (func) => {
      console.log(getType(self).name, func);
    }
  }
})).views((self) => ({
  options() {
    return self?.store?.getDataDeliveryTypes();
  },
}));
